import { writeCookie } from "common/utils/cookie";
import { redirectTo } from "common/utils/browser";
import "./continue-shopping-modal-sticker.scss";
import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import { BUSINESS_LINE } from "common/utils/app-registry/contants";

const $getStickerButton = () =>
  document.querySelector(".js-continue-shopping-modal-sticker-button");

export const init = () => {
  $getStickerButton()?.addEventListener("click", event => {
    event.preventDefault();
    const { url, artworkId } = event.target.dataset;
    writeCookie("uploaded_artwork_ids", JSON.stringify([artworkId]), 300);
    submitDtfEvent("add_stickers", {
      page: "pdp",
      pdp_type: "transfers",
      business_line: BUSINESS_LINE.STICKER
    });
    redirectTo(url);
  });
};

export default init;
